/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home__Hero__Title_Part_1Inputs */

const en_home__hero__title_part_1 = /** @type {(inputs: Home__Hero__Title_Part_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unleash the`)
};

/**
* | output |
* | --- |
* | "Unleash the" |
*
* @param {Home__Hero__Title_Part_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home__hero__title_part_1 = /** @type {((inputs?: Home__Hero__Title_Part_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home__Hero__Title_Part_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home__hero__title_part_1(inputs)
});